<template>
  <div>
    <div class="h-full">
      <div class="rounded bg-white">
        <div class="">
          <CogsBarChart></CogsBarChart>
        </div>
        <div class="mt-8">
          <CogsTextOnly></CogsTextOnly>
        </div>
        <div class="mt-8">
          <CogsByProduct></CogsByProduct>
        </div>
        <div class="mt-8">
          <CogsCharttextOnly></CogsCharttextOnly>
        </div>
      </div>
    </div>
</div>
</template>
<script>
import CogsBarChart from './cogsBarChart.vue';
import CogsByProduct from './cogsByProduct.vue';
import CogsCharttextOnly from './cogsCharttextOnly.vue';
import CogsTextOnly from './cogsTextOnly.vue';

export default {
  components: {
    CogsByProduct,
    CogsTextOnly,
    CogsBarChart,
    CogsCharttextOnly
},
  data () {
    return {
    }
  },
  created() {
  },
  beforeMount () {
  },
  mounted () {
    document.title = 'COGS ◾ ShipWork'
  },
  watch: {
  },
  methods: {
  },
  beforeDestroy () {
  }
}
</script>
<style scoped>
</style>
